export default "__VITE_ASSET__b965c78f__"